import services from 'services/module';
import {Strings} from 'Strings';

export class AnimatronPreviews {

    constructor() {}

    computeHeight(height: number, width: number, computedWidth: number, maxHeight?: number) {
        if (typeof maxHeight === 'undefined') {
            maxHeight = options.handHeld ? 1400 : 700;
        }
        const minHeight = 80;
        const computedHeight = (height || 450) / (width || 550) * computedWidth;
        return Math.min(maxHeight, Math.max(minHeight, computedHeight));
    };

    pickPreview(previews: Array<string>, width = 720) {
        const picked = _.find(previews, function (preview) {
            return /.*\/[a-z\d]*.(png|jpg)$/.test(preview) ||
                new RegExp('.*\/[a-z\\d\\_]*(-0)?_' + width + '.(png|jpg)$').test(preview);
        });
        if (angular.isUndefined(picked)) {
            if (angular.isArray(previews) && previews.length > 0) {
                return Strings.removeUrlProtocol(previews[0]);
            } else {
                return '';
            }
        } else {
            return Strings.removeUrlProtocol(picked);
        }
    };
}
services.service('AnimatronPreviews', AnimatronPreviews);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AnimatronPreviewsSvc.ts